import { CoveoSearchResult } from "@dcl-ue/coveo-search";
export var rehydrator = CoveoSearchResult.rehydrator;
export default rehydrator;